// extracted by mini-css-extract-plugin
export var actions = "_dv-g";
export var benefitCard = "_dv-b";
export var benefitIcon = "_dv-d";
export var benefitLabel = "_dv-f";
export var benefits = "_dv-a";
export var benefitsSection = "_dv-8";
export var bodyText = "_dv-7";
export var closeButton = "_dv-2";
export var content = "_dv-3";
export var eyebrow = "_dv-4";
export var heading = "_dv-5";
export var image = "_dv-i";
export var imagePanel = "_dv-h";
export var modal = "_dv-0";
export var offerCard = "_dv-c";
export var offerIcon = "_dv-e";
export var sectionLabel = "_dv-9";
export var shell = "_dv-1";
export var title = "_dv-6";